import React, { Component } from 'react';
import { Route, Redirect, withRouter } from 'react-router';
import { graphql, compose } from 'react-apollo';
import Spinner from '../../../spinner/spinner';
import { Tabs } from 'antd';
import Daily from './daily/daily';
import Weekly from './weekly/weekly';
import AllTime from './allTime/allTime';
import { activeSubPath } from '../../../../utilities/routes';
import { getChurchGroups, getRevivalWeeks } from '../queries/queries';

class GroupPage extends Component {
  onTabChange = (key) => this.props.history.push(key);
  tabPath = (name) => `${this.props.match.url}/${name}`;

  render() {
    if (this.props.churchGroups.loading || this.props.revivalWeeks.loading) {
      return <Spinner />;
    }

    const groups = this.props.churchGroups.church.groups.edges.map(edge => edge.node);
    const revivalWeeks = this.props.revivalWeeks.church.revival.weeks;

    return (
      <div>
        <Route exact path={`${this.props.match.url}`} render={() => <Redirect to={`${this.tabPath('daily')}`} />} />

        <Tabs className="statistic-types-tabs" type="line" size="small" animated={true}
              activeKey={`${activeSubPath(this.props.location.pathname, 'group')}`} onChange={this.onTabChange}>
          <Tabs.TabPane tab="Daily" key={`${this.tabPath('daily')}`}>
            <Route path={`${this.tabPath('daily')}`}
                   render={() => <Daily {...this.props} selectedChurchGroups={groups} />} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Weekly" key={`${this.tabPath('weekly')}`}>
            <Route path={`${this.tabPath('weekly')}`}
                   render={() => <Weekly {...this.props} selectedChurchGroups={groups} revivalWeeks={revivalWeeks} />} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="All Time" key={`${this.tabPath('allTime')}`}>
            <Route path={`${this.tabPath('allTime')}`}
                   render={() => <AllTime {...this.props} selectedChurchGroups={groups} />} />
          </Tabs.TabPane>
        </Tabs>
      </div>
    );
  }
}

export default withRouter(
  compose(
    graphql(getChurchGroups, {
      options: ({ selectedChurch }) => ({ variables: { id: selectedChurch.id } }),
      name: 'churchGroups'
    }),
    graphql(getRevivalWeeks, {
      options: ({ selectedChurch }) => ({ variables: { church_id: selectedChurch.id } }),
      name: 'revivalWeeks'
    })
  )
  (GroupPage)
);



// WEBPACK FOOTER //
// ./src/components/pages/statistics/group/groupPage.js